module.exports = __webpack_public_path__ + "img/WMS_bg2.4c070d30.png";